import React, { useEffect, useState } from 'react';
import { Typography, Box, Icon, List, Item } from '@worthy-npm/worthy-common-ui-components';

import { Step, StepContainer, StepGridContainer } from '../../../styles/common';
import { useAppDispatch, useAppSelector } from '../../../app/hooks';
import { selectCondition, updateCondition } from '../../../slices/submitSlice';
import { StepProps } from '../common';
import StepTitle from '../../stepTitle';
import { parametrize } from '../../../lib/commonUtils';
import GA from '../../../data/GA';
import { WatchConditions } from '../../../data/ItemDetails';

function StepCondition({
  next,
  active,
  idx,
  stepName,
  prev,
  title,
  stepCaption,
  props,
}: StepProps) {
  const dispatch = useAppDispatch();
  const condition = useAppSelector(selectCondition);

  const [busy, setBusy] = useState(false);
  useEffect(() => {
    if (!active) return;
    GA.stepView(stepName);
  }, [active]);

  return (
    <StepContainer data-automation="condition-step">
      <Step>
        <StepTitle
          stepCaption={stepCaption}
          idx={idx}
          prev={prev}
          stepTitle={title || 'What condition is your watch in?'}
          stepName={stepName}
          stepNotice="Select an option below"
          optionalProps={props || {}}
        />

        <StepGridContainer>
          <List spacing={2}>
            {WatchConditions.map((item) => (
              <Item
                data-automation={`condition-step-item-${parametrize(item.code)}`}
                key={item.code}
                variant="outlined"
                style={{ cursor: 'pointer' }}
                onClick={(e) => {
                  if (busy) return;
                  setBusy(true);
                  GA.select({ step: stepName, value: item.code });
                  dispatch(updateCondition(item.code));
                  setTimeout(() => {
                    next(e);
                    setTimeout(() => {
                      setBusy(false);
                    }, 600);
                  }, 600);
                }}
              >
                <Box
                  display="flex"
                  justifyContent="space-between"
                  alignItems="center"
                  width="100%"
                  data-testid={`condition-step-item-${parametrize(item.code)}`}
                >
                  <Box display="flex" flexDirection="row" alignItems="center">
                    <Typography variant="subtitle1" color="text.primary">
                      {item.text}
                    </Typography>
                  </Box>
                  <Box>{item.code === condition ? <Icon.GreenCheck display="block" /> : null}</Box>
                </Box>
              </Item>
            ))}
          </List>
        </StepGridContainer>
      </Step>
    </StepContainer>
  );
}

export default StepCondition;
